export const SIMPLE_ACTION = "SIMPLE_ACTION";
export const LOADING_PENDING = "LOADING_PENDING";
export const SIGN_OUT = "SIGN_OUT";
export const GET_DATA = "GET_DATA";
export const ERROR_MESSAGE = "ERROR_MESSAGE";
export const VALIDATE_USER_STARTED = "VALIDATE_USER_STARTED";
export const VALIDATE_USER_SUCCEEDED = "VALIDATE_USER_SUCCEEDED";
export const VALIDATE_USER_FAILED = "VALIDATE_USER_FAILED";
export const POST_CALL = "POST_CALL";
export const RESET_VALIDATE_USER = "RESET_VALIDATE_USER";
export const TRACK_INCREASE_COUNT = "TRACK_INCREASE_COUNT";
export const TRACK_DECREASE_COUNT = "TRACK_DECREASE_COUNT";
export const VALIDATE_TOKEN_STARTED = "VALIDATE_TOKEN_STARTED";
export const VALIDATE_TOKEN_SUCCEEDED = "VALIDATE_TOKEN_SUCCEEDED";
export const VALIDATE_TOKEN_FAILED = "VALIDATE_TOKEN_FAILED";
export const CREATE_NEW_PASSWORD_STARTED = "CREATE_NEW_PASSWORD_STARTED";
export const CREATE_NEW_PASSWORD_SUCEEDED = "CREATE_NEW_PASSWORD_SUCEEDED";
export const CREATE_NEW_PASSWORD_FAILED = "CREATE_NEW_PASSWORD_FAILED";
export const SET_ACCOUNT_TYPE = "SET_ACCOUNT_TYPE";
export const STORE_EMAIL = "STORE_EMAIL";
export const STORE_BUSINESS_TYPE = "STORE_BUSINESS_TYPE";
export const FETCH_USER_ACCOUNTS_STARTED = "FETCH_USER_ACCOUNTS_STARTED";
export const FETCH_USER_ACCOUNTS_SUCEEDED = "FETCH_USER_ACCOUNTS_SUCEEDED";
export const FETCH_USER_ACCOUNTS_FAILED = "FETCH_USER_ACCOUNTS_FAILED";
export const VERIFY_COMPANY_STARTED = "VERIFY_COMPANY_STARTED";
export const VERIFY_COMPANY_SUCEDEED = "VERIFY_COMPANY_SUCEDEED";
export const VERIFY_COMPANY_FAILED = "VERIFY_COMPANY_FAILED";
export const FINISH_SIGNATORY_STEPS = "FINISH_SIGNATORY_STEPS";
export const CHANGE_VALIDATION_STATE = "CHANGE_VALIDATION_STATE";
export const SET_BUSINESS_NUMBERS = "SET_BUSINESS_NUMBERS";
export const SET_USER_ACCOUNT_CHOICE = "SET_USER_ACCOUNT_CHOICE";
export const FETCH_SME_PROFILES_STARTED = "FETCH_SME_PROFILES_STARTED";
export const FETCH_SME_PROFILES_SUCCEEEDED = "FETCH_SME_PROFILES_SUCCEEEDED";
export const FETCH_SME_PROFILES_FAILED = "FETCH_SME_PROFILES_FAILED";
export const SET_IS_AUTHENTICATED = "SET_IS_AUTHENTICATED";
export const SET_UNAUTHENTICATE = "SET_UNAUTHENTICATE";
export const SET_USER_OBJ = "SET_USER_OBJ";
export const STORE_FIRST_NAME = "STORE_FIRST_NAME";
export const STORE_MIDDLE_NAME = "STORE_MIDDLE_NAME";
export const STORE_LAST_NAME = "STORE_LAST_NAME";
export const SET_ACCOUNT_MODAL = "SET_ACCOUNT_MODAL";
export const SET_PASSWORD_SHOW_MODAL = "SET_PASSWORD_SHOW_MODAL";
export const SET_IS_ONBOARDED = "SET_IS_ONBOARDED";
export const VALIDATE_KYC_STARTED = "VALIDATE_KYC_STARTED";
export const VALIDATE_KYC_SUCCEEEDED = "VALIDATE_KYC_SUCCEEEDED";
export const VALIDATE_KYC_FAILED = "VALIDATE_KYC_FAILED";
export const SET_KYC_ERROR_MODAL = "SET_KYC_ERROR_MODAL";
export const SET_COUNTRY = "SET_COUNTRY";
export const SET_STATE_OBJ = "SET_STATE_OBJ";
export const RESET_LGA = "RESET_LGA";
export const SET_LGA = "SET_LGA";
export const ADD_NEXT_OF_KIN = "ADD_NEXT_OF_KIN";
export const UPLOAD_FILE_STARTED = "UPLOAD_FILE_STARTED";
export const UPLOAD_FILE_SUCCEEDED = "UPLOAD_FILE_SUCCEEDED";
export const UPLOAD_FILE_FAILED = "UPLOAD_FILE_FAILED";
export const SET_NEXT_OF_KIN_INFO = "SET_NEXT_OF_KIN_INFO";
export const SET_CONFIRM_INFO = "SET_CONFIRM_INFO";
export const UPLOAD_BILL_STARTED = "UPLOAD_BILL_STARTED";
export const UPLOAD_BILL_SUCCEEEDED = "UPLOAD_BILL_SUCCEEEDED";
export const UPLOAD_BILL_FAILED = "UPLOAD_BILL_FAILED";
export const SET_IS_ACCOUNT_SETUP = "SET_IS_ACCOUNT_SETUP";
export const SET_DOB = "SET_DOB";
export const SET_NEW_ACCT_DETAILS = "SET_NEW_ACCT_DETAILS";
export const SELECTED_ACCT_TYPE = "SELECTED_ACCT_TYPE";
export const SET_NOK_RELATIONSHIP = "SET_NOK_RELATIONSHIP";
export const BUSINESS_USER_EXISTS = "BUSINESS_USER_EXISTS";
export const SET_SCUML_FILE = "SET_SCUML_FILE";
export const VALIDATE_KYC_ONGOING = "VALIDATE_KYC_ONGOING";
export const FIND_RETAIL_BUSINESS_STARTED = "FIND_RETAIL_BUSINESS_STARTED";
export const FIND_RETAIL_BUSINESS_SUCCEEDED = "FIND_RETAIL_BUSINESS_SUCCEEDED";
export const FIND_RETAIL_BUSINESS_FAILED = "FIND_RETAIL_BUSINESS_FAILED";
export const VALIDATE_USER_TOKEN_STARTED = "VALIDATE_USER_TOKEN_STARTED";
export const VALIDATE_USER_TOKEN_SUCCEEDED = "VALIDATE_USER_TOKEN_SUCCEEDED";
export const VALIDATE_USER_TOKEN_FAILED = "VALIDATE_USER_TOKEN_FAILED";
export const SEND_VALIDATION_TOKEN_STARTED = "SEND_VALIDATION_TOKEN_STARTED";
export const SEND_VALIDATION_TOKEN_SUCCEEDED = "SEND_VALIDATION_TOKEN_SUCCEEDED";
export const SEND_VALIDATION_TOKEN_FAILED = "SEND_VALIDATION_TOKEN_FAILED";
export const NON_TIER_THREE_CUSTOMER="NON_TIER_THREE_CUSTOMER";
export const FROM_INVITE_PAGE="FROM_INVITE_PAGE";

// NTB ONBOARDING
export const NTB_VALIDATE_EMAIL_STARTED = "NTB_VALIDATE_EMAIL_STARTED";
export const NTB_VALIDATE_EMAIL_SUCCEEDED = "NTB_VALIDATE_EMAIL_SUCCEEDED";
export const NTB_VALIDATE_EMAIL_FAILED = "NTB_VALIDATE_EMAIL_FAILED";
export const NTB_VALIDATE_EMAIL_OTP_STARTED = "NTB_VALIDATE_EMAIL_OTP_STARTED";
export const NTB_VALIDATE_EMAIL_OTP_SUCCEEDED = "NTB_VALIDATE_EMAIL_OTP_SUCCEEDED";
export const NTB_VALIDATE_EMAIL_OTP_FAILED = "NTB_VALIDATE_EMAIL_OTP_FAILED";
export const NTB_SEND_SMS_OTP_STARTED = "NTB_SEND_SMS_OTP_STARTED";
export const NTB_SEND_SMS_OTP_SUCCEEDED = "NTB_SEND_SMS_OTP_SUCCEEDED";
export const NTB_SEND_SMS_OTP_FAILED = "NTB_SEND_SMS_OTP_FAILED";
export const NTB_UPDTE_MATI_VERIFICATION_STATUS_STARTED = "NTB_UPDTE_MATI_VERIFICATION_STATUS_STARTED";
export const NTB_UPDTE_MATI_VERIFICATION_STATUS_SUCCEEDED = "NTB_UPDTE_MATI_VERIFICATION_STATUS_SUCCEEDED";
export const NTB_UPDTE_MATI_VERIFICATION_STATUS_FAILED = "NTB_UPDTE_MATI_VERIFICATION_STATUS_FAILED";